import { getRequest } from '../api-handler';
import { LabelTemplateDetailDto } from './labelTemplate';

export const LabelTemplateApi = {
  getById: (id: number) =>
    getRequest<LabelTemplateDetailDto>(`/labelTemplates/${id}`)
};
